import { useWorkspacesStore } from '@modules/workspaces'
import type { Workspace } from '@modules/workspaces/workspaces.type'

export function loadWorkspaceFromStore(): Workspace | null {
  return useWorkspacesStore.getState().currentWorkspace ?? useWorkspacesStore.getState().workspaces[0] ?? null
}
